<template lang="pug">
    .container(
        ref='container',
        )
        .animated-scroll(
            ref='animatedScroll',
            )
                .animation(ref='heart')
                    svg(width='100%' viewBox='0 0 1552 617' fill='none' xmlns='http://www.w3.org/2000/svg' preserveAspectRatio='xMidYMid meet')
                        g(ref='leftHalf')
                            path(d='M745.958 395.941L785.143 327.41L708.249 270.512L761.666 208.348L777.021 147.977C739.635 89.9253 691.908 64.6285 645.489 64.1226C553.734 63.1243 471.825 155.556 508.47 266.318C550.764 375.889 669.559 471.856 773.961 550.112L797.452 449.168L745.958 395.941Z' fill='black')
                        g(ref='bullet')
                            path(d='M679.5 327L673 321.5L672 304.5L721 303.5H773L776 307L769.5 316.5L752 322.5L732 324.5L723 326.5L679.5 327Z' fill='#FF0000')
                            path(d='M732.611 326.127C759.808 325.235 776.305 317.031 776.305 306.955C776.305 296.879 759.719 288.586 732.433 287.783C730.738 286 730.203 286.089 729.401 286.089L679.733 286.089C677.593 286.089 673.045 288.051 672.243 290.637L669.746 290.637L669.746 288.408C669.746 287.07 668.854 286 667.873 286C666.892 286 666.001 287.07 666.001 288.408L666.001 325.503C666.001 326.84 666.892 327.91 667.873 327.91C668.854 327.91 669.746 326.84 669.746 325.503L669.746 323.452L672.243 323.452C673.134 326.038 677.593 327.999 679.733 327.999L729.401 327.999C730.203 327.999 730.738 328.089 732.611 326.127ZM735.643 322.56L735.643 311.057C756.063 311.057 764.534 309.898 772.916 307.401C772.203 313.821 759.986 321.222 735.643 322.56ZM680.09 324.165C679.287 324.165 678.663 323.541 678.663 322.738L678.663 311.681C678.663 310.879 679.287 310.254 680.09 310.254L728.331 310.254C729.133 310.254 729.758 310.879 729.758 311.681L729.758 322.738C729.758 323.541 729.133 324.165 728.331 324.165L680.09 324.165Z' fill='black')
                        g(ref='rightHalf')
                            path(d='M908.293 67.1619C861.874 66.8661 813.715 91.3347 775.334 148.73L759.856 209.069L706.31 271.123L783.087 328.18L743.76 396.629L795.145 449.965L771.446 550.86C877.184 474.417 997.617 380.516 1041.8 271.694C1080.35 161.581 1000.05 67.7486 908.293 67.1619Z' fill='black')
</template>
<script>
import {gsap} from 'gsap';
import {mixinAnimation} from '../mixins/animatedScreen';

export default {
    props: {
        settings: Object,
        name: String,
        theme: String,
        bgTheme: String,
        isActive: Boolean
    },

    data() {
        return {
            bScrollInst: null,
            timeline: null,
            isInited: false,
            innerBlockPosition: 'top'
        };
    },
    mixins: [mixinAnimation],
    methods: {
        createTimeline() {
            this.timeline = gsap.timeline({paused: true});

            this.timeline
                .set(this.$refs.bullet, {x: '-300vw'})
                .set([this.$refs.leftHalf, this.$refs.rightHalf], {x: 0, rotate: 0})

                .fromTo(this.$refs.bullet, {x: '-300vw'}, {duration: 2, x: '0', ease: 'none'}, 0)

                .fromTo(this.$refs.leftHalf, {rotate: '0', x: 0}, {duration: 0.5, rotate: '-10', x: -40, ease: 'none', transformOrigin: '98% 100%'}, 2)
                .fromTo(this.$refs.rightHalf, {rotate: '0', x: 0}, {duration: 0.5, rotate: '10', x: 40, ease: 'none', transformOrigin: '12% 95%'}, 2)

                .fromTo(this.$refs.leftHalf, {rotate: '-10'}, {duration: 2, rotate: '-50', x: -30, ease: 'none', transformOrigin: '98% 100%'}, 3)
                .fromTo(this.$refs.rightHalf, {rotate: '10'}, {duration: 2, rotate: '50', x: 30, ease: 'none', transformOrigin: '12% 95%'}, 3)
                .fromTo(this.$refs.bullet, {x: '0vw'}, {duration: 2, x: '300vw', ease: 'none'}, 2);

            this.timeline.progress(0.0001);
            this.timeline.pause();
        },
        createAnimation() {
            this.createTimeline();
            this.createScroll();
        }
    }
};
</script>
<style lang="scss" scoped>
@import '../../assets/css/vars.scss';
.white {
    .animated-scroll {
        margin-bottom: 80px;
        @media (--viewport-laptop) {
            margin-bottom: 30px;
        }
    }
}
.container {
    height: 150vh;
    position: relative;
    overflow: hidden;
}

.animated-scroll {
    position: absolute;
    top: 0;
    left: 0;
    height: auto;
    min-height: 100vh;
    width: 100%;
    background-color: var(--theme);
    display: flex;

    &.fixed {
        position: fixed;
        top: 0;
        left: 0;
    }

    &.bottom {
        bottom: 0;
        top: auto;
    }
}

.animation {
    display: flex;
    align-items: center;
    margin: auto;
    width: 100%;
    height: 100%;
}

.bullet {
    position: absolute;
    padding: 0 50vw;
    width: 109vw;
    top: 50%;
    left: 0;
}
</style>
